export default function userAgentDetect(ua: string) {
  const regex = new RegExp(ua, 'gi');
  const userAgent = typeof window === 'undefined' ? '' : navigator.userAgent;
  const isMatch = Boolean(userAgent.match(regex));

  return isMatch;
}
